import React, { useEffect } from "react";
import {
  Routes,
  Route,
  BrowserRouter as Router,
  useLocation,
} from "react-router-dom";

import "./i18n";
import GaPageView from "./components/gaPageView";
import Home from "./pages/home";
import NotFoundPage from "./pages/notFound";
import Privacy from "./pages/privacy";
import AllRegions from "./pages/regionalstore/allRegions";
import RegionalStore from "./pages/regionalstore";
import TcgLandingPage from "./pages/tcgLanding";
import TrendingItem from "./pages/trendingItem";
import Auth from "./pages/auth";
import News from "./pages/news";
import OfficialNewsDetail from "./pages/news/detail";
import Community from "./pages/community";
import Profile from "./pages/profile";
import { AuthProvider } from "./contexts/AuthContext";
import { LocaleLayout } from "./i18n/LocaleRouting";

type AnymindWindow = Window & {
  startAnymindTS?: () => void;
  anymindTS?: {
    dispose?: () => void;
  };
};

function AtsLifecycle() {
  const location = useLocation();

  useEffect(() => {
    const atsWindow = window as AnymindWindow;
    try {
      atsWindow.startAnymindTS?.();
    } catch {
      // Ignore ATS runtime errors and keep page interactive.
    }

    return () => {
      try {
        atsWindow.anymindTS?.dispose?.();
      } catch {
        // Ignore ATS disposal errors during route transitions.
      }
    };
  }, [location.pathname, location.search]);

  return null;
}

function AppRouteTree() {
  return (
    <>
      <Route index element={<Home />} />
      <Route path="auth" element={<Auth />} />
      <Route path="profile" element={<Profile />} />
      <Route path="news" element={<News />} />
      <Route path="news/:brand/:slug" element={<OfficialNewsDetail />} />
      <Route path="community" element={<Community />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="trendingItem/:productId" element={<TrendingItem />} />
      <Route path="regionalstore" element={<AllRegions />} />
      <Route path="regionalstore/:area" element={<RegionalStore />} />
      <Route path=":brand/:slug" element={<TcgLandingPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <GaPageView />
        <AtsLifecycle />
        <Routes>
          <Route path="/" element={<LocaleLayout />}>
            {AppRouteTree()}
          </Route>
          <Route path="/ja" element={<LocaleLayout />}>
            {AppRouteTree()}
          </Route>
          <Route path="/zh-TW" element={<LocaleLayout />}>
            {AppRouteTree()}
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
